import browser from "webextension-polyfill";
export async function executeFunction(tabId, frameId, func, args = []) {
    if (typeof browser.scripting === "undefined" ||
        typeof browser.scripting.executeScript !== "function") {
        return;
    }
    const world = "MAIN";
    const injection = {
        target: { tabId, frameIds: [frameId] },
        world,
        injectImmediately: true,
        func,
        args,
    };
    await browser.scripting.executeScript(injection);
}
